module.exports = __webpack_public_path__ + "static/media/home.1fd9053a.png";